import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { BillingAddress, BillingAddressFields } from '../BillingAddress/BillingAddress';
import { Ach, AchFields } from '../Ach/Ach';
import { FormFooter } from '../FormFooter/FormFooter';
import { achInitialValues, achValidation } from '../Ach/Ach.meta';
import {
  billingAddressInitialValues,
  billingAddressValidation,
} from '../BillingAddress/BillingAddress.meta';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { setIsEditing } from '../../../../state';
import { useSavePaymentMutation } from '../../../../api/useSavePaymentMutation';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { routeParamsSelector } from '../../../../../CommonComponents/Router/Selector';
import { PaymentOptionsDTO } from '../../../../api/usePaymentQuery';

interface AchPaymentFields extends AchFields, BillingAddressFields {}

export const AchPayment: React.FC = () => {
  const { mutateAsync: savePayment, isLoading, error } = useSavePaymentMutation();

  const { clientId } = useSelector(routeParamsSelector);

  const dispatch = useDispatch();

  const formBag = useForm<AchPaymentFields>({
    defaultValues: {
      ...achInitialValues,
      ...billingAddressInitialValues,
    },

    resolver: yupResolver(achValidation.concat(billingAddressValidation)),
  });

  const onSubmit = useCallback(
    async data => {
      try {
        await savePayment({
          clientId,
          data: { ...data, paymentOption: PaymentOptionsDTO.ACH },
        });

        dispatch(setIsEditing(false));
      } catch {
        // Ignore
      }
    },
    [clientId, dispatch, savePayment],
  );

  return (
    <form onSubmit={formBag.handleSubmit(onSubmit)}>
      <ModalBody>
        {error && <Alert message={error.message} variant="error" my="16" />}

        <Ach formBag={formBag as any} mb="24" />

        <BillingAddress formBag={formBag as any} />
      </ModalBody>

      <FormFooter isLoading={isLoading} />
    </form>
  );
};
